"use client";
import { jsx as i } from "react/jsx-runtime";
import * as o from "react";
import { getContrastTextColor as u } from "./index16.js";
const f = o.createContext(null);
function d(r) {
  const { branding: e } = r.tenant, t = document.documentElement;
  e.brandPrimary && (t.style.setProperty("--brand-primary", e.brandPrimary), t.style.setProperty("--brand-primary-foreground", u(e.brandPrimary))), e.brandSecondary && t.style.setProperty("--brand-secondary", e.brandSecondary), e.brandAccent && (t.style.setProperty("--brand-accent", e.brandAccent), t.style.setProperty("--brand-accent-foreground", u(e.brandAccent)));
}
function P({ children: r, config: e, fetchUrl: t }) {
  const [l, c] = o.useState(e ?? null), [y, a] = o.useState(!e);
  return o.useEffect(() => {
    if (e) {
      c(e), d(e), a(!1);
      return;
    }
    if (!t) {
      a(!1);
      return;
    }
    let s = !1;
    return a(!0), fetch(t).then((n) => {
      if (!n.ok) throw new Error("Failed to fetch tenant config");
      return n.json();
    }).then((n) => {
      s || (c(n), d(n));
    }).catch((n) => {
      console.error("TenantProvider: failed to load config", n);
    }).finally(() => {
      s || a(!1);
    }), () => {
      s = !0;
    };
  }, [t, e]), /* @__PURE__ */ i(f.Provider, { value: { config: l, isLoading: y }, children: r });
}
function m() {
  const r = o.useContext(f);
  if (!r) throw new Error("useTenant must be used within a TenantProvider");
  return r;
}
function T(r) {
  const { config: e } = m();
  return (e == null ? void 0 : e.tenant.featureFlags[r]) ?? !1;
}
export {
  P as TenantProvider,
  T as useFeatureFlag,
  m as useTenant
};
//# sourceMappingURL=index14.js.map
